import { Image as ImageIcon, Play } from "lucide-react";
import { cn } from "@/lib/cn";

/**
 * Placeholder for image or video assets. Renders a 16:9 (default) frame with
 * subtle grid texture. Future iterations can swap with real <img> or <video>.
 */
export const MediaPlaceholder = ({
  ratio = "16/9",
  label = "Visual placeholder",
  kind = "image", // "image" | "video"
  className,
  testId,
}) => {
  const Icon = kind === "video" ? Play : ImageIcon;
  return (
    <div
      data-testid={testId || "media-placeholder"}
      className={cn(
        "relative w-full overflow-hidden rounded-xl border border-dashed border-border bg-surface/60",
        className
      )}
      style={{ aspectRatio: ratio }}
    >
      <div
        className="absolute inset-0 grid-dot-bg opacity-60"
        aria-hidden="true"
      />
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 text-muted-foreground">
        <div className="flex h-9 w-9 items-center justify-center rounded-full border border-border bg-background">
          <Icon className="h-4 w-4" />
        </div>
        <div className="text-xs font-medium tracking-wide">{label}</div>
      </div>
    </div>
  );
};

export default MediaPlaceholder;
